module.exports = __webpack_public_path__ + "img/page-23.27e8da3f.jpg";